import { render, staticRenderFns } from "./MobileSideMenuItem.vue?vue&type=template&id=7770855e&scoped=true"
import script from "./MobileSideMenuItem.vue?vue&type=script&lang=js"
export * from "./MobileSideMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MobileSideMenuItem.vue?vue&type=style&index=0&id=7770855e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770855e",
  null
  
)

export default component.exports